<template>
  <div class="profile">
    <div class="container py-5">
      <h1 class="text-center mb-5">Profile</h1>
      <div class="row">
        <div class="col-md-8 mx-auto">
          <div class="card">
            <div class="card-body text-center">
              <h5 class="card-title">Coming Soon</h5>
              <p class="card-text">This feature is under development.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Profile',
}
</script>
